import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { WalletItemMedicalCard } from "../../../store/common";
import * as httpClient from "../../../util/httpClient";
import { Notification } from "../../common/Notification";
import { useForm } from "react-hook-form";
import { getFlowByName } from "../../../config/FlowName";
import * as NextStepFlowAction from "../../../store/nextStepFlowService/actions";
import { ApplicationState } from "../../../store";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { useTranslation } from "react-i18next";

const MedicalIdCardDialog: React.FunctionComponent<{ requestDataCallback(): void; walletItem: WalletItemMedicalCard; isNew: boolean; closeDialog(): void }> = (
    props
) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [isLoading, setisLoading] = useState(false);

    const dispatch = useDispatch();
    const lostWalletFlow = useSelector((state: ApplicationState) => getFlowByName(state, "LOST-WALLET-ASSISTANCE"));
    const completeGetStartedItem = (flowID: any, flowName: string) => dispatch(NextStepFlowAction.actionCreators.completeGetStartedItem(flowID, flowName));
    const [medicalCard, setMedicalCard] = useState(props.walletItem);
    const [errorMsg, seterrorMsg] = useState("");
    const [hasError, setHasError] = useState(false);

    const [issueDate, setIssueDate] = useState({
        issueMonth: props.walletItem.issueDate ? props.walletItem.issueDate.trim().split("/")[0] : "",
        issueDay: props.walletItem.issueDate ? props.walletItem.issueDate.trim().split("/")[1] : "",
        issueYear: props.walletItem.issueDate ? props.walletItem.issueDate.trim().split("/")[2] : "",
    });

    const months = [
        { name: "Jan", value: "01" },
        { name: "Feb", value: "02" },
        { name: "Mar", value: "03" },
        { name: "Apr", value: "04" },
        { name: "May", value: "05" },
        { name: "Jun", value: "06" },
        { name: "Jul", value: "07" },
        { name: "Aug", value: "08" },
        { name: "Sep", value: "09" },
        { name: "Oct", value: "10" },
        { name: "Nov", value: "11" },
        { name: "Dec", value: "12" },
    ];

    /**Validation with react-hook-form ***/
    const { register, errors, formState, handleSubmit } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
    });

    const { isValid, isSubmitting } = formState;

    useEffect(() => {
        if (issueDate) {
            if (
                issueDate.issueDay &&
                issueDate.issueDay.length > 0 &&
                issueDate.issueMonth &&
                issueDate.issueMonth.length > 0 &&
                issueDate.issueYear &&
                issueDate.issueYear.length > 0
            ) {
                setMedicalCard({ ...medicalCard, issueDate: issueDate.issueMonth + "/" + issueDate.issueDay + "/" + issueDate.issueYear });
            } else {
                setMedicalCard({
                    ...medicalCard,
                    issueDate: undefined,
                });
            }
        }
    }, [issueDate]);

    function onIssueDateChangeHandler(event: any) {
        setHasError(false);
        const elName = event.currentTarget.name;
        setIssueDate({ ...issueDate, [elName as string]: event.currentTarget.value });
    }

    const closeDialog = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    const refresWalletItem = () => {
        closeDialog();
        props.requestDataCallback();
    };

    function onChnageHandler(event: any) {
        setHasError(false);
        const elName = event.currentTarget.name;
        setMedicalCard({ ...medicalCard, [elName as string]: event.currentTarget.value });
    }

    const saveItem = () => {
        const requestBody = {
            "lost-wallet": {
                "lost-wallet-medicalcard": medicalCard,
            },
        };
        setisLoading(true);
        httpClient
            .sendRequest("POST", "api/lostWallet/" + (props.isNew ? "addNewWalletItem" : "updateWalletItem"), requestBody)
            .then((data) => {
                setisLoading(false);
                if (data.isSuccess) {
                    if (lostWalletFlow && lostWalletFlow.flowStepStatus !== "COMPLETED") {
                        completeGetStartedItem(lostWalletFlow.flowStepId, lostWalletFlow.flowName ? lostWalletFlow.flowName : " ");
                    }
                    Notification({
                        type: "success",
                        title: props.isNew
                            ? tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.addToastTitle")
                            : tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.updateToastTitle"),
                        message: props.isNew
                            ? tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.addToastMessage")
                            : tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.updateToastMessage"),
                    });
                    refresWalletItem();
                } else if (data.hasError && data.errors.length > 0) {
                    seterrorMsg(data.errors.join(", "));
                    setHasError(true);
                } else {
                    seterrorMsg(tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.unknownError"));
                    setHasError(true);
                }
            })
            .catch(function (error) {
                setisLoading(false);
                Notification({
                    type: "error",
                    title: tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.errorToastTitle"),
                    message: tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.errorToastMesage"),
                    duration: 0,
                });
                closeDialog();
            });
    };
    const issueDateFields = [
        <div className="col-xs-4 col-no-gutter">
            <div className="form-row row">
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-issue-day">Issue Day</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register}
                        name="issueDay"
                        className="inputbox"
                        id="label-issue-day"
                        aria-labelledby="label-issue-day"
                        defaultValue={issueDate.issueDay}
                        onChange={onIssueDateChangeHandler}
                    >
                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.dropdownHeaders.dateDay")}</option>
                        {Array(31)
                            .fill(null)
                            .map((value, index) => {
                                return (
                                    <option key={index + 1} value={index < 9 ? "0" + (index + 1) : index + 1}>
                                        {index < 9 ? "0" + (index + 1) : index + 1}
                                    </option>
                                );
                            })}
                    </select>
                </div>
            </div>
        </div>,
        <div className="col-xs-4 col-no-gutter">
            <div className="form-row row">
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-issue-month">Issue Month</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register}
                        name="issueMonth"
                        className="inputbox"
                        id="label-issue-month"
                        aria-labelledby="label-issue-month"
                        defaultValue={issueDate.issueMonth}
                        onChange={onIssueDateChangeHandler}
                    >
                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.dropdownHeaders.dateMonth")}</option>
                        {months.map((month) => {
                            return (
                                <option key={month.value} value={month.value}>
                                    {month.name}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
        </div>,
        <div className="col-xs-4 col-no-gutter">
            <div className="form-row row">
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-issue-year">Issue Year</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register}
                        name="issueYear"
                        className="inputbox"
                        id="label-issue-year"
                        aria-labelledby="label-issue-year"
                        defaultValue={issueDate.issueYear}
                        onChange={onIssueDateChangeHandler}
                    >
                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.dropdownHeaders.dateYear")}</option>
                        {Array(100)
                            .fill(null)
                            .map((value, index) => {
                                const optionValue = new Date().getFullYear() - index;
                                return (
                                    <option key={optionValue} value={optionValue}>
                                        {optionValue}
                                    </option>
                                );
                            })}
                    </select>
                </div>
            </div>
        </div>,
    ];
    return (
        <React.Fragment>
            {!isLoading ? (
                <>
                    <div className="dialog-header">
                        <div className="dialog-icon">
                            <em className={props.isNew ? "las la-plus" : "las la-edit"}></em>
                        </div>
                        <h1>
                            {props.isNew
                                ? tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.addLabel")
                                : tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.editLabel")}{" "}
                            {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.title")}
                        </h1>
                    </div>

                    <form onSubmit={handleSubmit(saveItem)} id="medical-id-card-info-form-container">
                        <div className="dialog-body">
                            <div className={errors["cardType"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-card-type">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.cardType")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-card-type"
                                            aria-labelledby="edit-card-type"
                                            name="cardType"
                                            defaultValue={medicalCard.cardType}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                required: true,
                                                pattern: /^.+$/,
                                            })}
                                            maxLength={30}
                                        />
                                        {errors.cardType && errors.cardType.type === "pattern" && (
                                            <span className="form-error">
                                                Invalid Format. Card Type can only include letters, spaces, and the special characters: -'.
                                            </span>
                                        )}

                                        {errors.cardType && errors.cardType.type === "required" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.validationMessage.cardType.required")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["memberName"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-member-name">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.memberName")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-member-name"
                                            aria-labelledby="edit-member-name"
                                            name="memberName"
                                            defaultValue={medicalCard.memberName}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                required: true,
                                                pattern: /^[a-zA-Z\s\-']+$/,
                                            })}
                                            maxLength={30}
                                        />
                                        {errors.memberName && errors.memberName.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.validationMessage.memberName.pattern")}
                                            </span>
                                        )}

                                        {errors.memberName && errors.memberName.type === "required" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.validationMessage.memberName.required")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["memberId"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-member-id">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.memberId")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-member-id"
                                            aria-labelledby="edit-member-id"
                                            name="memberId"
                                            defaultValue={medicalCard.memberId}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                required: true,
                                                pattern: /^[a-zA-Z0-9]+$/,
                                                minLength: 4,
                                            })}
                                            maxLength={30}
                                        />
                                        {errors.memberId && errors.memberId.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.validationMessage.memberId.pattern2")}
                                            </span>
                                        )}

                                        {errors.memberId && errors.memberId.type === "minLength" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.validationMessage.memberId.pattern")}
                                            </span>
                                        )}

                                        {errors.memberId && errors.memberId.type === "required" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.validationMessage.memberId.required")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["providerName"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-provider-name">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.providerName")}
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-provider-name"
                                            aria-labelledby="edit-provider-name"
                                            name="providerName"
                                            defaultValue={medicalCard.providerName}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                pattern: /^[a-zA-Z\s\-']+$/,
                                            })}
                                            maxLength={30}
                                        />
                                        {errors.providerName && errors.providerName.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.validationMessage.providerName.pattern")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["providerPhoneNumber"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-provider-phone-number">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.providerPhone")}
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-provider-phone-number"
                                            aria-labelledby="edit-provider-phone-number"
                                            name="providerPhoneNumber"
                                            defaultValue={medicalCard.providerPhoneNumber}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                pattern: /^$|^[(]?\d{3}[)]?[-.\s]?\d{3}[-.\s]?\d{4}$/,
                                            })}
                                        />
                                        {errors.providerPhoneNumber && errors.providerPhoneNumber.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.validationMessage.providerPhoneNumber.pattern")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["providerAddress"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-provider-address">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.providerAddress")}
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-provider-address"
                                            aria-labelledby="edit-provider-address"
                                            name="providerAddress"
                                            defaultValue={medicalCard.providerAddress}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                pattern: /^[a-zA-Z0-9-#,/.\s]+$/,
                                            })}
                                            maxLength={100}
                                        />
                                        {errors.providerAddress && errors.providerAddress.type === "pattern" && (
                                            <span className="form-error">
                                                Invalid format. Provider Address can only include letters, numbers, and the special characters: #-/,.
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="label-issue-month">{tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.issueDate")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="row ">
                                        {i18nService.get("Country") == "US" ? (
                                            <>
                                                {issueDateFields[1]} {issueDateFields[0]} {issueDateFields[2]}{" "}
                                            </>
                                        ) : i18nService.get("Country") == "CA" || i18nService.get("Country") == "TW" ? (
                                            <>
                                                {issueDateFields[2]} {issueDateFields[1]} {issueDateFields[0]}{" "}
                                            </>
                                        ) : (
                                            <>
                                                {issueDateFields[0]} {issueDateFields[1]} {issueDateFields[2]}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-group">{tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.group")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <input
                                        type="text"
                                        className="inputbox"
                                        id="edit-group"
                                        aria-labelledby="edit-group"
                                        name="group"
                                        maxLength={10}
                                        defaultValue={medicalCard.group}
                                        onChange={onChnageHandler}
                                    />
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-bin">{tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.bin")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <input
                                        type="text"
                                        className="inputbox"
                                        id="edit-bin"
                                        aria-labelledby="edit-bin"
                                        name="bin"
                                        maxLength={30}
                                        defaultValue={medicalCard.bin}
                                        onChange={onChnageHandler}
                                    />
                                </div>
                            </div>

                            {hasError && (
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter"></div>
                                    <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <p className="form-error">{errorMsg}</p>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="dialog-footer">
                            <div className="row between-xs">
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => closeDialog()}>
                                        <span className="btn-text">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.cancelButtonText")}
                                        </span>
                                    </button>
                                </div>
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="submit" className="btn-default btn-primary" disabled={isSubmitting}>
                                        <span className="btn-text">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.saveButtonText")}
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </>
            ) : (
                <div className="box loading"></div>
            )}
        </React.Fragment>
    );
};

export default MedicalIdCardDialog;
